import { Navigate, Route, Routes } from "react-router-dom";
import { DeskLayout } from "./components/DeskLayout";
import { RequireAuth } from "./components/RequireAuth";
import { ToastProvider } from "./components/Toast";
import { AuthProvider } from "./context/AuthContext";
import { PdrSchemaProvider } from "./context/PdrSchemaContext";
import { CompanyExportPage } from "./pages/CompanyExportPage";
import { EvidencePage } from "./pages/EvidencePage";
import { LoginPage } from "./pages/LoginPage";
import { LogsPage } from "./pages/LogsPage";
import { PdrSchemaPage } from "./pages/PdrSchemaPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { SearchPage } from "./pages/SearchPage";
import { EvalPlaygroundPage } from "./pages/EvalPlaygroundPage";
import { VendorClustersPage } from "./pages/VendorClustersPage";
import { VendorAdminPage } from "./pages/VendorAdminPage";
import { BudgetPage } from "./pages/BudgetPage";

export default function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route
              element={
                <PdrSchemaProvider>
                  <DeskLayout />
                </PdrSchemaProvider>
              }
            >
              <Route index element={<Navigate to="/search" replace />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/evidence" element={<EvidencePage />} />
              <Route path="/vendor-clusters" element={<VendorClustersPage />} />
              <Route path="/vendors" element={<VendorAdminPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/export" element={<CompanyExportPage />} />
              <Route path="/pdr-schema" element={<PdrSchemaPage />} />
              <Route path="/synthesis" element={<Navigate to="/vendor-clusters" replace />} />
              <Route path="/budget" element={<BudgetPage />} />
              <Route path="/logs" element={<LogsPage />} />
              <Route path="/eval-playground" element={<EvalPlaygroundPage />} />
              {/* Legacy paths */}
              <Route path="/phase1" element={<Navigate to="/search" replace />} />
              <Route path="/phase2" element={<Navigate to="/evidence" replace />} />
              <Route path="/phase3" element={<Navigate to="/vendor-clusters" replace />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </ToastProvider>
  );
}
